import PhotoSwipeLightbox from 'photoswipe/dist/photoswipe-lightbox.esm';
import PhotoSwipe from 'photoswipe/dist/photoswipe.esm.js';
import 'photoswipe/dist/photoswipe.css';

import {createGalleryCaptions, createThumbnailsSlider, galleryOnClose, galleryOnExpand} from './gallery-utilities';

export default () => {
  const galleryMoreBtn = document.querySelector('.gallery-more button');
  const galleries = document.querySelectorAll('.lightbox-gallery');

  if(!galleries.length) return;

  galleries.forEach((gallery) => {
    const lightbox = new PhotoSwipeLightbox({
      gallery: gallery,
      children: 'a',
      showHideAnimationType: 'none',
      padding: { top: 55, bottom: 70, left: 40, right: 40 },
      pswpModule: () => PhotoSwipe,
    });

    lightbox.init();

    createGalleryCaptions(lightbox);
    createThumbnailsSlider(lightbox);
    galleryOnClose(lightbox);
  });

  if(!galleryMoreBtn) return;
  
  galleryOnExpand(galleryMoreBtn, galleries);
}
